module.exports = __webpack_public_path__ + "static/img/question_bird.5396bcc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/webcast/popup/question_bird.gif
// module id = z5KR
// module chunks = 1